export enum EFileTypes {
    CHARGER_DETAILS = "charger_details",
    CANCELLED_CHEQUE = "cancelled_cheque",
    OWNER_COMPANY_RELATION_DOC = "owner_company_relation_doc",
    SPOT_IMAGE = "spot_image",
    EVC_AFFIDAVIT = "evc_affidavit",
    ELECTRICITY_BILL = "electricity_bill",
    ELECTRICITY_BILL_SURVEY = "electricity_bill_survey",
    RENT_AGREEMENT = "rent_agreement",
    KYC_DOCUMENT = "kyc_document",
    NOC_HOST = "noc_host",
    BANK_DETAILS = "bank_details",
    AGREEMENT_REPORT = "agreement_report",
    AGREEMENT_DOC = "agreement_doc",
    GST_CERTIFICATE = "gst_certificate",
    CPO_GST_CERTIFICATE = "cpo_gst_certificate",
    CPO_BANK_DETAILS = "cpo_bank_details",
    CLIENT_GST_CERTIFICATE = "client_gst_certificate",
    PURCHASE_ORDER = "purchase_order",
    INVOICE = "invoice",
    EWAY_BILL_FILES = "eway_bill_files",
    CHARGER_DETAILS_FORMAT = "charger_details_format",
    DC_FILES = "dc_files",
    BILL_OF_QUANTITY = "bill_of_quantity",
    FOUNDATION_IMAGES = "foundation_images",
    CHARGER_INSTALLATION_IMAGES = "charger_installation_images",
    COMMISSIONING_REPORT = "commissioning_report",
    FINAL_SITE_IMAGES = "final_site_images",
    COMPLETION_REPORT = "completion_report",
    HANDOVER_REPORT = "handover_report",
    FINAL_BILL = "final_bill",
    WIR_FILE = "wir_file",
    MIR_FILE = "mir_file",
    EVIDENCE_SCREENSHOTS = "evidence_screenshots",
    EV_APPLICATION_IMAGES = "ev_application_images",
    DN_NOTE_IMAGES = "dn_note_images",
    METER_QUOTE_IMAGES = "meter_quote_images",
    EVC_IMAGES = "evc_images",
    TRANS_HPOLE_IMAGES = "trans_hpole_images",
    POST_SURVEY_IMAGES = "post_survey_images",
    POST_DELIVERY_IMAGES = "post_delivery_images",
    PROOF_OF_DELIVERY_IMAGES = "proof_of_delivery_images",
    CONNECTION_IMAGES = "connection_images",
    SURVEY_SPOT_IMAGES = "survey_spot_images",
    BILL_OF_QUANTITY_TEMPLATE = "bill_of_quantity_template",
    COMMISSIONING_REPORT_TEMPLATE = "commissioning_report_template",
    SURVEY = "survey",
    PROJECT_COMPLETION_REPORT_FORMAT = "project_completion_report_format",
    WORK_INSPECTION_REPORT = "work_inspection_report",
    MATERIALS_INSPECTION_REPORT = "materials_inspection_report",
    DELIVERY_REQUEST = "delivery_request",
    CHARGER_TEMPLATE_FORMAT = "charger_template_format",
    FINAL_COSTS = "final_costs",
    GSR_ITEM_MASTER = "gsr_item_master",
    GSR_FORM = "gsr_form",
    CLOSURE_DOCUMENT = "closure_document",
    DISMANTLING_IMAGES = "dismantling_images",
    PACK_LOAD_IMAGES = "pack_load_images",
    DEMOLITION_IMAGES = "demolition_images",
    CLEANUP_IMAGES = "cleanup_images",
    CUSTOMER_FEEDBACK_FORM = "customer_feedback_form",
    DELIVERY_CHALLAN = "delivery_challan",
    SURVEY_SPOT = "survey_spot",
    BANK_DETAILS_CPO = "bank_details_cpo",
    CPO_AGREEMENT = "cpo_agreement",
    STATIQ_METER_IMAGE = "statiq_meter_image",
    BILLING_METER_IMAGE = "billing_meter_image",
    AMC = "amc",
    INFRA_DOC = "infra_doc",
    PROPERTY_PAPER = "property_paper",
    OTHER_DOC = "other_doc",
    NOC = "noc",
    INFRA_DOCUMENT = "infra_document",
    FRANCHISE_AGREEMENT = "franchise_agreement",
}
